import React from "react";
import Slider from "react-slick";

//REACT SLICK NOT WORKING WITH IE11

function SampleNextArrow(props) {
    const { className, onClick } = props;

    return (
        <div className={className} onClick={onClick}>
            <i className="fal fa-chevron-right" aria-hidden="true" />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
        <div className={className} onClick={onClick}>
            <i className="fal fa-chevron-left" aria-hidden="true" />
        </div>
    );
}

function trimText(text, numChars) {
    if (text.length > numChars) {
        let words = (text.substring(0, numChars)).split(/\s/gi); // truncate at number of characters, then split on whitespace

        let ret = "";

        for (let i = 0; i < words.length - 1; i++) { // skip the last result
            if (i == words.length - 2) {
                ret += words[i] + "...";
            } else {
                ret += words[i] + " ";
            }
        }
        return ret;
    }
    return text;
}

class ArticleWidget extends React.Component {
    renderArticleImage = (article) => {
        let src = "../../assets/LM-Subscribe-Banner.jpg";

        return (
            article.sortedPictureTagData ?
                <picture>
                    {
                        article.sortedPictureTagData.sourceTagData.map((data, index) => {
                            return (
                                <source key={index} media={data.media} srcSet={data.srcset} type={data.type} />
                            );
                        })
                    }
                    <img className={article.sortedPictureTagData.imageTagData.class} src={article.sortedPictureTagData.imageTagData.src} alt={article.sortedPictureTagData.imageTagData.alt} title={article.sortedPictureTagData.imageTagData.title}></img>
                </picture>
                :
                <img src={src}/>
        );
    }

    cleanArticleSummary = articleSummary => {
        const cleanSummary = {
            __html: articleSummary.replace(new RegExp("(<p>|</p>)", "g"), "")
        };

        return cleanSummary;
    }

    // componentDidMount() {
    //     console.log(this.props);
    // }

    render() {
        const { articles } = this.props;
        const defaultConfig = {
            dots: true,
            lazyLoad: true,
            infinite: articles.length > 3,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 720,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
        };
        const config = {
            ...defaultConfig,
            ...this.props.config
        };

        return (
            <div className="full-width" id={config.title}>
                {config.title &&
                    <h2 className="title h1">{config.title}</h2>
                }
                <div className="articleTabList">
                    <Slider {...config} className={articles.length > 3 ? "" : "left-align-slick"} >
                        {
                            articles.map(article => {
                                return (
                                    <div key={article.articleNo}>
                                        <div
                                            className="articleTab forMedia"
                                            key={article.articleNo}
                                        >
                                            <div className="articleTabImg">
                                                <a href={article.fullSlug}>
                                                    <div className="article-tab-img">
                                                        {this.renderArticleImage(
                                                            article
                                                        )}
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="articleTabText">
                                                <header>
                                                    {/*
                                                        <a href={article.fullSlug}>
                                                            Product Name
                                                        </a>
                                                    */}
                                                    <a href={article.fullSlug}>
                                                        <h2
                                                            className="h3 max-2-lines l-h-3"
                                                            dangerouslySetInnerHTML={{
                                                                __html: trimText(
                                                                    article.title,
                                                                    80
                                                                )
                                                            }}
                                                        ></h2>
                                                    </a>
                                                    {/*
                                                        <span className="h5 summary max-3-lines" dangerouslySetInnerHTML={this.cleanArticleSummary(article.summary)}></span>
                                                    */}
                                                </header>
                                                <footer>
                                                    {article.logoData && (
                                                        <div className="sponsor-logo">
                                                            <picture>
                                                                {article.logoData.sourceTagData.map(
                                                                    (
                                                                        data,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <source
                                                                                key={
                                                                                    index
                                                                                }
                                                                                media={
                                                                                    data.media
                                                                                }
                                                                                srcSet={
                                                                                    data.srcset
                                                                                }
                                                                                type={
                                                                                    data.type
                                                                                }
                                                                            />
                                                                        );
                                                                    }
                                                                )}
                                                                <img
                                                                    className={
                                                                        article
                                                                            .logoData
                                                                            .imageTagData
                                                                            .class
                                                                    }
                                                                    src={
                                                                        article
                                                                            .logoData
                                                                            .imageTagData
                                                                            .src
                                                                    }
                                                                    alt={
                                                                        article
                                                                            .logoData
                                                                            .imageTagData
                                                                            .alt
                                                                    }
                                                                    title={
                                                                        article
                                                                            .logoData
                                                                            .imageTagData
                                                                            .title
                                                                    }
                                                                ></img>
                                                            </picture>
                                                        </div>
                                                    )}
                                                    {/*
                                                        <a className="m-b-1" href={article.fullSlug}>
                                                            <FontAwesomeIcon icon={ faInfoSquare } />
                                                            Further Information
                                                        </a>
                                                    */}
                                                </footer>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                        {this.SampleNextArrow}
                    </Slider>
                </div>
            </div>
        );
    }
}

export default ArticleWidget;
